import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAtomValue } from 'jotai';
import { getSDK } from '../services/sdk-instance';
import { bridgeEventStreamAtom, daemonPushFrameStreamAtom } from '../stores/sdk/atoms';
import { SESSION_LIST_PAGES_KEY, SESSION_SEARCH_PAGES_KEY } from './useSessionList';

/**
 * Reconnect invalidation (sdk ADR-b2a2e):
 * when the event transport reconnects, every cache entry goes stale and heals
 * by refetch — never replay. The binding is host-side (subscribe + call
 * through, sdk ADR-377c6); the eviction policy is the SDK caches'.
 */
export function useCacheReconnectInvalidation(): void {
  const queryClient = useQueryClient();
  const webStream = useAtomValue(bridgeEventStreamAtom);
  const daemonStream = useAtomValue(daemonPushFrameStreamAtom);
  const stream = webStream ?? daemonStream;

  useEffect(() => {
    if (!stream || !('onOpen' in stream)) return;
    const off = (stream as { onOpen: (handler: () => void) => () => void }).onOpen(() => {
      getSDK().historyCache.evictAll();
      getSDK().listCache.evictAll();
      getSDK().searchCache.evictAll();
      getSDK().feedCache.evictAll();
      void queryClient.invalidateQueries({ queryKey: SESSION_LIST_PAGES_KEY });
      void queryClient.invalidateQueries({ queryKey: SESSION_SEARCH_PAGES_KEY });
    });
    return off;
  }, [stream, queryClient]);
}
